import { render, staticRenderFns } from "./EditorEmail.vue?vue&type=template&id=c0098202&scoped=true"
import script from "./EditorEmail.vue?vue&type=script&lang=js"
export * from "./EditorEmail.vue?vue&type=script&lang=js"
import style0 from "./EditorEmail.vue?vue&type=style&index=0&id=c0098202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0098202",
  null
  
)

export default component.exports